export default {
  loc_country_select: {
    rs: "Serbia",
    bg: "Bulgaria",
    ro: "Romania",
    gr: "Greece",
    hr: "Croatia",
    si: "Slovenia",
    tr: "Turkey",
    hu: "Hungary",
    sk: "Slovakia",
    cz: "Czech Republic",
    lt: "Lithuania",
    es: "Estonia",
    pl: "Poland",
  },
  loc_city_select: {
    rs_001: "Aleksinac",
    rs_002: "Beograd",
    rs_003: "Bečej",
    rs_004: "Bor",
    rs_005: "Valjevo",
    rs_006: "Vlasina",
    rs_007: "Vranje",
    rs_008: "Vrnjačka Banja",
    rs_009: "Vršac",
    rs_010: "Gornji Milanovac",
    rs_011: "Divčibare",
    rs_012: "Zaječar",
    rs_013: "Zlatibor",
    rs_014: "Zrenjanin",
    rs_015: "Kikinda",
    rs_016: "Kopaonik",
    rs_017: "Kragujevac",
    rs_018: "Kraljevo",
    rs_019: "Kruševac",
    rs_020: "Kuršumlija",
    rs_021: "Leskovac",
    rs_022: "Niš",
    rs_023: "Novi Pazar",
    rs_024: "Novi Sad",
    rs_025: "Pančevo",
    rs_026: "Požarevac",
    rs_027: "Sombor",
    rs_028: "Senta",
    rs_029: "Sjenica",
    rs_030: "Sremska Mitrovica",
    rs_031: "Ćuprija",
    rs_032: "Užice",
    rs_033: "Čačak",
    rs_034: "Šabac",
    rs_035: "Šid",
    rs_036: "Priština",
    rs_037: "Prizren",
    rs_038: "Subotica",
    rs_039: "Smederevo",
    rs_040: "Pirot",
    rs_041: "Jagodina",
    rs_042: "Prokuplje",
    bg_001: "Айтос",
    bg_002: "Ардино",
    bg_003: "Асеновград",
    bg_004: "Балчик",
    bg_005: "Белоградчик",
    bg_006: "Берковица",
    bg_007: "Благоевград",
    bg_008: "Бойчиновци",
    bg_009: "Ботевград",
    bg_010: "Брезник",
    bg_011: "Бургас",
    bg_012: "Бяла",
    bg_013: "Бяла Слатина",
    bg_014: "Варна",
    bg_015: "Велинград",
    bg_016: "Видин",
    bg_017: "Враца",
    bg_018: "Габрово",
    bg_019: "Генерал Тошево",
    bg_020: "Годеч",
    bg_021: "Горна Оряховица",
    bg_022: "Гоце Делчев",
    bg_023: "Горни Чифлик",
    bg_024: "Грудово",
    bg_025: "Девин",
    bg_026: "Димитровград",
    bg_027: "Добрич",
    bg_028: "Дряново",
    bg_029: "Дулово",
    bg_030: "Дупница",
    bg_031: "Елена",
    bg_032: "Елен Пелин",
    bg_033: "Елхово",
    bg_034: "Златарица",
    bg_035: "Ивайловград",
    bg_036: "Исперих",
    bg_037: "Ихтиман",
    bg_038: "Казанлък",
    bg_039: "Карлово",
    bg_040: "Карнобат",
    bg_041: "Кнежа",
    bg_042: "Копривщица",
    bg_043: "Котел",
    bg_044: "Крумовград",
    bg_045: "Кубрат",
    bg_046: "Кула",
    bg_047: "Кърджали",
    bg_048: "Кюстендил",
    bg_049: "Ловеч",
    bg_050: "Лом",
    bg_051: "Луковит",
    bg_052: "Мадан",
    bg_053: "Малко Търново",
    bg_054: "Момчилград",
    bg_055: "Монтана",
    bg_056: "Никопол",
    bg_057: "Нова Загора",
    bg_058: "Нови Пазар",
    bg_059: "Омуртаг",
    bg_060: "Оряхово",
    bg_061: "Павликени",
    bg_062: "Пазарджик",
    bg_063: "Панагюрище",
    bg_064: "Перник",
    bg_065: "Петрич",
    bg_066: "Пещера",
    bg_067: "Пирдоп",
    bg_068: "Плевен",
    bg_069: "Пловдив",
    bg_070: "Поморие",
    bg_071: "Попово",
    bg_072: "Преслав",
    bg_073: "Провадия",
    bg_074: "Първомай",
    bg_075: "Радомир",
    bg_076: "Разград",
    bg_077: "Разлог",
    bg_078: "Русе",
    bg_079: "Самоков",
    bg_080: "Сандански",
    bg_081: "Свиленград",
    bg_082: "Свищов",
    bg_083: "Своге",
    bg_084: "Севлиево",
    bg_085: "Силистра",
    bg_086: "Сливен",
    bg_087: "Сливница",
    bg_088: "Смолян",
    bg_089: "София",
    bg_090: "Созопол",
    bg_091: "Стара Загора",
    bg_092: "Тервел",
    bg_093: "Тетевен",
    bg_094: "Топловград",
    bg_095: "Троян",
    bg_096: "Трън",
    bg_097: "Трявна",
    bg_098: "Тутракан",
    bg_099: "Търговище",
    bg_100: "Велико Търново",
    bg_101: "Харманли",
    bg_102: "Хасково",
    bg_103: "Хисаря",
    bg_104: "Царево",
    bg_105: "Чепеларе",
    bg_106: "Чирпан",
    bg_107: "Шумен",
    bg_108: "Ямбол",
    ro_001: "Adamclisi",
    ro_002: "Alba Iulia",
    ro_003: "Alexandria",
    ro_004: "Arad",
    ro_005: "Bacau",
    ro_006: "Baia Mare",
    ro_007: "Barlad",
    ro_008: "Bistrita",
    ro_009: "Blaj",
    ro_010: "Botosani",
    ro_011: "Brasov",
    ro_012: "Braila",
    ro_013: "Bucuresti",
    ro_014: "Buzau",
    ro_015: "Calafat",
    ro_016: "Calarasi",
    ro_017: "Campina",
    ro_018: "Campulung Moldovenesc",
    ro_019: "Campulung Muscel",
    ro_020: "Caracal",
    ro_021: "Caransabes",
    ro_022: "Cluj-Napoca",
    ro_023: "Constanta",
    ro_024: "Craiova",
    ro_025: "Curtea de Arges",
    ro_026: "Deva",
    ro_027: "Dorohoi",
    ro_028: "Dragasani",
    ro_029: "Fagaras",
    ro_030: "Foscani",
    ro_031: "Galati",
    ro_032: "Giurgiu",
    ro_033: "Gura Honi (Arad)",
    ro_034: "Grivita ( Ialomita)",
    ro_035: "Husi",
    ro_036: "Iasi",
    ro_038: "Lugoj",
    ro_039: "Mangalia",
    ro_040: "Medgidia",
    ro_041: "Miercurea Ciuc",
    ro_042: "Odorheiu Secuiesc",
    ro_043: "Oradea",
    ro_044: "Oravita",
    ro_045: "Paltinis (Sibiu)",
    ro_046: "Petrosani",
    ro_047: "Piatra Neamt",
    ro_048: "Pitesti",
    ro_049: "Ploiesti",
    ro_050: "Poiana Stampei",
    ro_051: "Predeal",
    ro_052: "Ramnicu Sarat",
    ro_053: "Ramnicu Valcea",
    ro_054: "Resita",
    ro_055: "Roman",
    ro_056: "Sata Mare",
    ro_057: "Sebes",
    ro_058: "Sfantu Gheorghe",
    ro_059: "Sibiu",
    ro_060: "Sighisoara",
    ro_061: "Sinaia(cota 1500)",
    ro_062: "Slatina",
    ro_063: "Slobozia",
    ro_064: "Suceava",
    ro_065: "Sulina",
    ro_066: "Targoviste",
    ro_067: "Targu Jiu",
    ro_068: "Targu Mures",
    ro_069: "Targu Ocna",
    ro_070: "Targu Secuiesc",
    ro_071: "Tecuci",
    ro_072: "Timisoara",
    ro_073: "Tulcea",
    ro_074: "Turda",
    ro_075: "Turnu Magurele",
    ro_076: "Drobeta Turnu Severin",
    ro_077: "Urziceni",
    ro_078: "Vaslui",
    ro_079: "Vatra Dornei",
    ro_080: "Zalau",
    gr_001: "Αγχίαλος",
    gr_002: "Αγρίνιο",
    gr_003: "Αλεξανδρούπολη",
    gr_004: "Αλιάρτος",
    gr_005: "Ανδραβίδα",
    gr_006: "Άραξος",
    gr_007: "Άργος / Πυργέλα",
    gr_008: "Αργοστόλι",
    gr_009: "Άρτα",
    gr_010: "Αθήνα / Φιλαδέλφεια",
    gr_011: "Αθήνα / Ελληνικό",
    gr_012: "Χαλκίδα",
    gr_013: "Χανιά",
    gr_014: "Χίος",
    gr_015: "Χρυσόπουλη",
    gr_016: "Δράμα",
    gr_017: "Έδεσσα",
    gr_018: "Ελευσίνα",
    gr_019: "Φλώρινα",
    gr_020: "Ιεράπετρα",
    gr_021: "Ιωάννινα",
    gr_022: "Ηράκλειο",
    gr_023: "Καλαμάτα",
    gr_024: "Καρδίτσα",
    gr_025: "Κάρυστος",
    gr_026: "Καρπενήσι",
    gr_027: "Καστοριά",
    gr_028: "Καβάλα",
    gr_029: "Κέρκυρα",
    gr_030: "Κύθηρα",
    gr_031: "Κομοτηνή",
    gr_032: "Κόνιτσα",
    gr_033: "Κόρινθος / Βέλο",
    gr_034: "Κως",
    gr_035: "Κοζάνη",
    gr_036: "Λαμία",
    gr_037: "Λάρισα",
    gr_038: "Λευκάδα",
    gr_039: "Λήμνος",
    gr_040: "Μεθώνη",
    gr_041: "Μήλος",
    gr_042: "Μυτιλήνη",
    gr_043: "Νάξος",
    gr_044: "Πάρος",
    gr_045: "Πάτρα",
    gr_046: "Πύργος",
    gr_047: "Πολύγυρος",
    gr_048: "Πρέβεζα",
    gr_049: "Ρέθυμνο",
    gr_050: "Ρόδος",
    gr_051: "Σάμος",
    gr_052: "Σέρρες",
    gr_053: "Σύρος",
    gr_054: "Σητεία",
    gr_055: "Σκύρος",
    gr_056: "Σούδα",
    gr_057: "Σπάρτη",
    gr_058: "Τανάγρα",
    gr_059: "Θεσσαλονίκη",
    gr_060: "Θήρα",
    gr_061: "Τρίκαλα Ημαθίας",
    gr_062: "Τρίκαλα Θεσσαλίας",
    gr_063: "Τρίπολις",
    gr_064: "Τιμπάκιον",
    gr_065: "Ξάνθη",
    gr_066: "Ζάκυνθος",
    hr_001: "Belje",
    hr_002: "Bjelovar",
    hr_003: "Daruvar",
    hr_004: "Gospić",
    hr_005: "Gradište",
    hr_006: "Hvar",
    hr_007: "Dubrovnik",
    hr_008: "Imotski",
    hr_009: "Karlovac",
    hr_010: "Knin",
    hr_011: "Komiža",
    hr_012: "Koprivnica",
    hr_013: "Krapina",
    hr_014: "Križevci",
    hr_015: "Makarska",
    hr_016: "Mali Lošinj",
    hr_017: "Našice",
    hr_018: "Ogulin",
    hr_019: "Osijek",
    hr_020: "Pazin",
    hr_021: "Ploče",
    hr_022: "Poreč",
    hr_023: "Požega",
    hr_024: "Pula",
    hr_025: "Rab",
    hr_026: "Rijeka",
    hr_027: "Samobor",
    hr_028: "Senj",
    hr_029: "Sisak",
    hr_030: "Slatina",
    hr_031: "Slavonski Brod",
    hr_032: "Slunj",
    hr_033: "Split",
    hr_034: "Stubičke Toplice",
    hr_035: "Sunja",
    hr_036: "Šibenik",
    hr_037: "Varaždin",
    hr_038: "Vinkovci",
    hr_039: "Zadar",
    hr_040: "Zagreb (Grič)",
    hr_041: "Zagreb (Maksimir)",
    si_001: "Celje",
    si_002: "Jesenice",
    si_003: "Kamnik",
    si_004: "Kočevje",
    si_005: "Koper",
    si_006: "Kranj",
    si_007: "Krško",
    si_008: "Kredarica",
    si_009: "Ljubljana",
    si_010: "Maribor",
    si_011: "Murska Sobota",
    si_012: "Nova Gorica",
    si_013: "Novo Mesto",
    si_014: "Piran",
    si_015: "Planica",
    si_016: "Portorož",
    si_017: "Postojna",
    si_018: "Rateče",
    tr_001: "Adana",
    tr_002: "Adıyaman",
    tr_003: "Afyonkarahisar",
    tr_004: "Ağrı",
    tr_005: "Aksaray",
    tr_006: "Amasya",
    tr_007: "Ankara",
    tr_008: "Antalya",
    tr_009: "Ardahan",
    tr_010: "Artvin",
    tr_011: "Aydın",
    tr_012: "Balıkesir",
    tr_013: "Bartın",
    tr_014: "Batman",
    tr_015: "Bayburt",
    tr_016: "Bilecik",
    tr_017: "Bingöl",
    tr_018: "Bitlis",
    tr_019: "Bolu",
    tr_020: "Burdur",
    tr_021: "Bursa",
    tr_022: "Çanakkale",
    tr_023: "Çankırı",
    tr_024: "Çorum",
    tr_025: "Denizli",
    tr_026: "Diyarbakır",
    tr_027: "Düzce",
    tr_028: "Edirne",
    tr_029: "Elazığ",
    tr_030: "Erzincan",
    tr_031: "Erzurum",
    tr_032: "Eskişehir",
    tr_033: "Gaziantep",
    tr_034: "Giresun",
    tr_035: "Gümüşhane",
    tr_036: "Hakkari",
    tr_037: "Hatay",
    tr_038: "Isparta",
    tr_039: "Mersin",
    tr_040: "Iğdır",
    tr_041: "İstanbul",
    tr_042: "İzmir",
    tr_043: "Kahramanmaraş",
    tr_044: "Karabük",
    tr_045: "Karaman",
    tr_046: "Kars",
    tr_047: "Kastamonu",
    tr_048: "Kayseri",
    tr_049: "Kilis",
    tr_050: "Kırıkkale",
    tr_051: "Kırklareli",
    tr_052: "Kırşehir",
    tr_053: "Kocaeli",
    tr_054: "Konya",
    tr_055: "Kütahya",
    tr_056: "Malatya",
    tr_057: "Manisa",
    tr_058: "Mardin",
    tr_059: "Muğla",
    tr_060: "Muş",
    tr_061: "Nevşehir",
    tr_062: "Niğde",
    tr_063: "Ordu",
    tr_064: "Osmaniye",
    tr_065: "Rize",
    tr_066: "Sakarya",
    tr_067: "Samsun",
    tr_068: "Siirt",
    tr_069: "Sinop",
    tr_070: "Sivas",
    tr_071: "Şanlıurfa",
    tr_072: "Şırnak",
    tr_073: "Tekirdağ",
    tr_074: "Tokat",
    tr_075: "Trabzon",
    tr_076: "Tunceli",
    tr_077: "Uşak",
    tr_078: "Van",
    tr_079: "Yalova",
    tr_080: "Yozgat",
    tr_081: "Zonguldak",
    hu_001: "Budapest",
    hu_002: "Budapest(Budaörs)",
    hu_003: "Baja",
    hu_004: "Békéscsaba",
    hu_005: "Debrecen",
    hu_006: "Dunaújváros",
    hu_007: "Eger",
    hu_008: "Gyöngyös",
    hu_009: "Győr",
    hu_010: "Kaposvár",
    hu_011: "Kecskemét",
    hu_012: "Kékestető",
    hu_013: "Mátraháza",
    hu_014: "Miskolc",
    hu_015: "Mosonmagyaróvár",
    hu_016: "Nagykanizsa",
    hu_017: "Nyíregyháza",
    hu_018: "Pápa",
    hu_019: "Pécs",
    hu_020: "Salgótarján",
    hu_021: "Szeged",
    hu_022: "Szolnok",
    hu_023: "Tatabánya",
    hu_024: "Veszprém",
    hu_025: "Záhony",
    sk_001: "Banská Bystrica",
    sk_002: "Bardejov",
    sk_003: "Bratislava",
    sk_004: "Čadca",
    sk_005: "Dolný Kubín",
    sk_006: "Dunajská Streda",
    sk_007: "Galanta",
    sk_008: "Humenné",
    sk_009: "Komárno",
    sk_010: "Košice",
    sk_011: "Levice",
    sk_012: "Liptovský Mikuláš",
    sk_013: "Lučenec",
    sk_014: "Martin",
    sk_015: "Michalovce",
    sk_016: "Nitra",
    sk_017: "Nové Zámky",
    sk_018: "Poprad",
    sk_019: "Považská Bystrica",
    sk_020: "Prešov",
    sk_021: "Prievidza",
    sk_022: "Rimavská Sobota",
    sk_023: "Rožňava",
    sk_024: "Senica",
    sk_025: "Spišská Nová Ves",
    sk_026: "Stará Ľubovňa",
    sk_027: "Topoľčany",
    sk_028: "Trebišov",
    sk_029: "Trenčín",
    sk_030: "Trnava",
    sk_031: "Zvolen",
    sk_032: "Žiar nad Hronom",
    sk_033: "Žilina",
    sk_034: "Bánovce nad Bebravou",
    sk_035: "Banská Štiavnica",
    sk_036: "Brezno",
    sk_037: "Bytča",
    sk_038: "Detva",
    sk_039: "Dolný Kubín",
    sk_040: "Dunajská Streda",
    sk_041: "Gelnica",
    sk_042: "Hlohovec",
    sk_043: "Ilava",
    sk_044: "Kežmarok",
    sk_045: "Krupina",
    sk_046: "Kysucké Nové Mesto",
    sk_047: "Levoča",
    sk_048: "Malacky",
    sk_049: "Medzilaborce",
    sk_050: "Myjava",
    sk_051: "Námestovo",
    sk_052: "Nové Mesto nad Váhom",
    sk_053: "Pezinok",
    sk_054: "Piešťany",
    sk_055: "Poltár",
    sk_056: "Púchov",
    sk_057: "Revúca",
    sk_058: "Ružomberok",
    sk_059: "Sabinov",
    sk_060: "Senec",
    sk_061: "Skalica",
    sk_062: "Snina",
    sk_063: "Sobrance",
    sk_064: "Stropkov",
    sk_065: "Svidník",
    sk_066: "Šaľa",
    sk_067: "Turčianske Teplice",
    sk_068: "Tvrdošín",
    sk_069: "Veľký Krtíš",
    sk_070: "Vranov nad Topľou",
    sk_071: "Zlaté Moravce",
    sk_072: "Žarnovica",
    cz_001: "Brno",
    cz_002: "Č.Budejovice",
    cz_003: "Hradec",
    cz_004: "Jihlava",
    cz_005: "Karlovy Vary",
    cz_006: "Kralove",
    cz_007: "Liberec",
    cz_008: "Olomouc",
    cz_009: "Ostrava",
    cz_010: "Pardubice",
    cz_011: "Plzen",
    cz_012: "Prague",
    cz_013: "Usti Nad Labem",
    cz_014: "Zlin",
    lt_001: "Biržai",
    lt_002: "Dotnuva",
    lt_003: "Dūkštas",
    lt_004: "Kaunas",
    lt_005: "Klaipėda",
    lt_006: "Kybartai",
    lt_007: "Lazdijai",
    lt_008: "Laukuva",
    lt_009: "Nida",
    lt_010: "Panevėžys",
    lt_011: "Raseiniai",
    lt_012: "Šilutė",
    lt_013: "Šiauliai",
    lt_014: "Telšiai",
    lt_015: "Ukmergė",
    lt_016: "Utena",
    lt_017: "Varėna",
    lt_018: "Vėžaičiai",
    lt_019: "Vilnius",
    es_001: "Kuressaare",
    es_002: "Pärnu",
    es_003: "Tallinn",
    es_004: "Tartu",
    es_005: "Väike-Maarja",
    es_006: "Võru",
    pl_001: "Białystok",
    pl_002: "Bydgoszcz",
    pl_003: "Gorzów Wiel",
    pl_004: "Gdańsk",
    pl_005: "Katowice",
    pl_006: "Kielce",
    pl_007: "Kraków",
    pl_008: "Lublin",
    pl_009: "Łódź",
    pl_010: "Olsztyn",
    pl_011: "Opole",
    pl_012: "Poznań",
    pl_013: "Rzeszów",
    pl_014: "Szczecin",
    pl_015: "Toruń",
    pl_016: "Warszawa",
    pl_017: "Wrocław",
    pl_018: "Zielona Góra",
  },
  app_sklopovi_a_title: {
    _1_1: "Hollow clay block",
    _1_2: "Hollow clay block with thermal insulation",
    _1_3: "Lightweight concrete block",
    _1_4: "Solid brick wall",
    _1_5: "Hollow brick or block wall",
    _1_6: "Hollow brick or block wall with thermal insulation",
    _1_7: "Reinforced concrete wall",
    _1_8: "Reinforced concrete wall with thermal insulation",
    _1_9: "Stone wall",
    _1_10: "Wooden frame construction with filling",
    _1_11: "Earth wall",
    _1_12: "Wooden wall",
    _1_13: "Concrete block wall",
    _1_14: "Three layer wall: brick/block + air + brick",
    _1_15: "Three layer wall: brock/block + insulation + brick",
    _1_16: "Thermal block wall",
    _1_17: "Steamed gas concrete wall",
    _1_18: "Steamed gas concrete wall with insulation",
    _1_19: "Reinforced concrete wall lined with fassade brick",
    _1_20: "Three layer wall: reinforced concrete + insulation + brick",
    _5_1: "Reinforced concrete slab",
    _5_2: 'Reinforced concrete "fine-ribbed" ceiling',
    _5_3: "Reinforced concrete semi-prefabricated ceiling",
    _5_4: "Reinforced concrete slab",
    _5_5: "Reinforced concrete slab",
    _5_6: "Lightweight concrete slab",
    _7_1: "Inclinated reinforced concrete slab",
    _7_2: "Inclinated reinforced concrete semi-prefabricated ceiling",
    _7_3: "Inclinated wooden roof structure",
    _7_4: "Inclinated wooden roof structure, partially insulated",
    _7_5: "Insulated inclinated wooden roof structure",
    _7_6: "Inclined reinforced concrete slab with thermal insulation",
    _10_1: "Wooden window with single glass",
    _10_2: "Metal window with single glass",
    _10_3: "PVC window with single glass",
    _10_4: "Wooden window with split wings",
    _10_5: "Wooden window with joint wings",
    _10_6: "Wooden single-wing window with double glass",
    _10_7: "Wooden window with double glass package",
    _10_8: "Wooden window with double glass package",
    _10_9: "Wooden window with triple glass package",
    _10_10: "Wooden window with low emitting double glass package",
    _10_11: "Wooden window with low emitting double glass krypton package",
    _10_12: "PVC five-chamber with double glass package",
    _10_13: "PVC five-chamber with double glass package",
    _10_14: "PVC six-chamber with low emitting double glass package",
    _10_15: "PVC six-chamber with low emitting double glass krypton package",
    _10_16: "PVC six-chamber with low emitting triple glass krypton package",
    _10_17: "Aluminium frame with thermal brake",
    _10_18: "Aluminium frame with thermal brake",
    _10_19: "Aluminium frame with thermal brake",
    _10_20: "Aluminium frame with thermal brake",
    _10_21: "Aluminium frame with improoved thermal brake",
    _10_22: "Aluminium frame with improoved thermal brake",
    _10_23: "Aluminium frame with improoved thermal brake",
    _10_24: "Metal window (no thermal brake) double grazed",
    _10_25: "Double glazed low -e, synthetic frame",
    _10_26: "Double glazed low -e, synthetic frame",
    _10_27: "Double glazed low -e, synthetic frame",
    _10_28: "Double glazed low -e, synthetic frame",
    _10_29: null,
    _10_30: null,
    _10_31: null,
    _10_32: null,
    _13_1: "Solid wooden door",
    _13_2: "Insulated wooden door",
    _13_3: "Uninsulated metal door",
    _13_4: "Insulated metal door",
    _13_5: "Wooden door with glass insertion",
    _13_6: "Metal glazed door",
    _13_7: "PVC door",
    _13_8: "Safety door",
    _13_9: "missing",
    _18_1: "Reinforced concrete slab",
    _18_2: 'Reinforced concrete "fine-ribbed" ceiling',
    _18_3: "Reinforced concrete semi-prefabricated ceiling",
    _18_4: "Wooden construction",
    _18_5: "Wooden construction",
    _18_6: "Partially insulated wooden construction",
    _18_7: "Insulated reinforced concrete slab",
    _18_8: "Insulated reinforced concrete semi-prefabricated construction",
    _18_9: "missing",
    _18_101: "Reinforced concrete slab",
    _18_102: 'Reinforced concrete "fine-ribbed" ceiling',
    _18_103: "Reinforced concrete semi-prefabricated ceiling",
    _18_104: "Wooden construction",
    _18_105: "Wooden construction",
    _18_106: "Partially insulated wooden construction",
    _18_107: "Insulated reinforced concrete slab",
    _18_108: "Insulated reinforced concrete semi-prefabricated construction",
    _18_109: "missing",
    _19_1: "Reinforced concrete slab",
    _19_2: 'Reinforced concrete "fine-ribbed" construction',
    _19_3: 'Reinforced concrete "fine-ribbed" construction with reed ceiling',
    _19_4: "Insulated reinforced concrete semi-prefabricated construction",
    _19_5: "Wooden construction (ribs)",
    _19_6: "Wooden construction (ribs) with reed layer",
    _19_7: "„Prussian arch“",
    _19_8: "Solid brick arch",
    _19_9: "Reinforced concrete slab with floor insulation",
    _19_10: "Insulated reinforced concrete semi-prefabricated construction with floor insulation",
    _19_11: "Reinforced concrete slab with floor insulation",
    _20_1: "Basement stone wall",
    _20_2: "Basement solid brick wall",
    _20_3: "Reinforced concrete basement wall",
    _20_4: "Reinforced concrete basement wall",
    _21_1: "Earth floor",
    _21_2: "Uninsulated floor (all kinds)",
    _21_3: "Uninsulated floor (all kinds)",
    _21_4: "Floor (all kinds) above the cement base",
  },
  app_sklopovi_a_select: {
    _1_1: "Hollow clay block, no thermal insulation, both sides plastered.",
    _1_2: "Hollow clay block, both sides plastered, with existing but not satisfactory thermal insulation from the outside.",
    _1_3: "Lightweight concrete block, no thermal insulation, both sides plastered.",
    _1_4: "Solid brick wall, no thermal insulation, both sides plastered.",
    _1_5: "Hollow brick or hollow block wall, no thermal insulation, both sides plastered.",
    _1_6: "Hollow brick or hollow block wall, both sides plastered, with existing but not satisfactory thermal insulation from the outside.",
    _1_7: "Reinforced concrete wall, no thermal insulation, both sides plastered.",
    _1_8: "Reinforced concrete wall, both sides plastered, with existing but not satisfactory thermal insulation.",
    _1_9: "Stone wall",
    _1_10: "Wooden frame construction with filling",
    _1_11: "Earth wall",
    _1_12: "Wooden wall",
    _1_13: "Concrete block wall, both sides plastered",
    _1_14: "Three layer wall made of hollow brick or hollow  block, lined with fassade brick with air layer in between",
    _1_15:
      "Three layer wall made of hollow brick or hollow block, lined with fassade brick with insulation layer in between",
    _1_16: "Thermal block wall, both sides plastered",
    _1_17: "Steamed gas concrete wall, no insulation, both sides plastered",
    _1_18: "Steamed gas concrete wall with insulation",
    _1_19: "Reinforced concrete wall, plastered on the inside and lined with fassade brick on the outside",
    _1_20: "Three layer wall made of reinforced concrete, lined with fassade brick, with insulation layer in between",
    _5_1: "Reinforced concrete slab, no thermal insulation, with waterproofing and mechanical protection on the outside",
    _5_2: 'Reinforced concrete "fine-ribbed" ceiling. Mortar over reeds and slats on the lower side and waterproofing and mechanical protection layers on the upper side. No thermal insulation.',
    _5_3: "Reinforced concrete semi-prefabricated ceiling with hollow clay blocks as filling. Waterproofing and mechanical protection layers on the upper side. No thermal insulation.",
    _5_4: "Reinforced concrete slab with thermal insulation, with waterproofing and mechanical protection on the outside",
    _5_5: "Reinforced concrete slab with thermal insulation and ventilation layer, with waterproofing and mechanical protection on the outside",
    _5_6: "Lightweight concrete slab, no insulation, with waterproofing and mechanical protection on the outside",
    _7_1: "Inclined reinforced concrete slab, no insulation. Roof cover on wooden substructure with additional waterproofing layer.",
    _7_2: "Inclined reinforced concrete semi-prefabricated ceiling with hollow clay block filling. Roof cover on wooden substructure with additional waterproofing layer.",
    _7_3: "Inclined wooden structure, no thermal insulation. Roof cover on wooden substructure with additional waterproofing layer.",
    _7_4: "Inclined wooden structure, partially insulated between the rafters.\r\nRoof cover on wooden substructure with additional waterproofing layer.",
    _7_5: "Inclined wooden structure with thermal insulation between the rafters with full thickness of rafters.\r\nRoof cover on wooden substructure with additional waterproofing layer.",
    _7_6: "Inclined reinforced concrete slab with thermal insulation.\r\nRoof cover on wooden substructure with additional waterproofing layer.",
    _10_1: "Wooden window with single glass",
    _10_2: "Metal window with single glass",
    _10_3: "PVC window with single glass",
    _10_4: "Wooden window with split wings",
    _10_5: "Wooden window with joint wings",
    _10_6: "Wooden single-wing window with double glass",
    _10_7: "Wooden window with double glass package 4+12+4",
    _10_8: "Wooden window with double glass package 6+12+6",
    _10_9: "Wooden window with triple glass package 6+12+6+12+6",
    _10_10: "Wooden window with low emitting double glass package 4+12+4",
    _10_11: "Wooden window with low emitting double glass krypton package 4+12+4",
    _10_12: "PVC five-chamber with double glass package 4+12+4",
    _10_13: "PVC five-chamber with double glass package 6+12+6",
    _10_14: "PVC six-chamber with low emitting double glass package 4+12+4",
    _10_15: "PVC six-chamber with low emitting double glass krypton package 4+12+4",
    _10_16: "PVC six-chamber with low emitting triple glass krypton package 4+8+4+8+4",
    _10_17: "Aluminium frame with thermal brake, double glass package 4+12+4",
    _10_18: "Aluminium frame with thermal brake, double glass package 6+16+6",
    _10_19: "Aluminium frame with thermal brake, double glass package 6+12+6+12+6",
    _10_20: "Aluminium frame with thermal brake, with low emitting double glass package 4+12+4",
    _10_21: "Aluminium frame with improoved thermal brake, with low emitting double glass krypton package 4+12+4",
    _10_22: "Aluminium frame with improoved thermal brake, with low emitting triple glass krypton package 6+16+6+16+6",
    _10_23: "Metal window (no thermal brake) double grazed 6mm?",
    _10_24: "Metal window (no thermal brake) double grazed 12mm?",
    _10_25: "Double glazed low -e, synthetic frame, according to KENAK (Zone A)",
    _10_26: "Double glazed low -e, synthetic frame, according to KENAK (Zone B)",
    _10_27: "Double glazed low -e, synthetic frame, according to KENAK (Zone C)",
    _10_28: "Double glazed low -e, synthetic frame, according to KENAK (Zone D)",
    _10_29: null,
    _10_30: null,
    _10_31: null,
    _10_32: null,
    _13_1: "Solid wooden door",
    _13_2: "Insulated wooden door",
    _13_3: "Uninsulated metal door",
    _13_4: "Insulated metal door",
    _13_5: "Wooden door with glass insertion",
    _13_6: "Metal glazed door",
    _13_7: "PVC door",
    _13_8: "Safety door",
    _18_1: "Reinforced concrete slab, no insulation, plastered on the lower side",
    _18_2: 'Reinforced concrete "fine-ribbed" construction. Mortar over reeds and slats on the  lower side.',
    _18_3:
      "Reinforced concrete semi-prefabricated construction with hollow clay blocks as filling. No insulation, plastered on the lower side",
    _18_4: "Wooden construction, beams, decking above, with embankment, no ceiling",
    _18_5: "Wooden construction, beams, decking above, with embankment, mortar over reeds and slats on the lower side.",
    _18_6:
      "Wooden construction, beams, decking above, with embankment, mortar over reeds and slats on the lower side. Space between beams partially covered with insulation.",
    _18_7: "Reinforced concrete slab with insulation on the upper side and plastered on the lower side.",
    _18_8:
      "Reinforced concrete semi-prefabricated construction with hollow clay blocks as filling. Insulation on the upper side and plastered on the lower side.",
    _18_9: "missing",
    _18_101: "Reinforced concrete slab, no insulation, plastered on the lower side",
    _18_102: 'Reinforced concrete "fine-ribbed" construction. Mortar over reeds and slats on the  lower side.',
    _18_103:
      "Reinforced concrete semi-prefabricated construction with hollow clay blocks as filling. No insulation, plastered on the lower side",
    _18_104: "Wooden construction, beams, decking above, with embankment, no ceiling",
    _18_105:
      "Wooden construction, beams, decking above, with embankment, mortar over reeds and slats on the lower side.",
    _18_106:
      "Wooden construction, beams, decking above, with embankment, mortar over reeds and slats on the lower side. Space between beams partially covered with insulation.",
    _18_107: "Reinforced concrete slab with thermal insulation on the upper side and plastered on the lower side.",
    _18_108:
      "Reinforced concrete semi-prefabricated construction with hollow clay blocks as filling. Insulation on the upper side and plastered on the lower side.",
    _18_109: "missing",
    _19_1:
      "Reinforced concrete slab, no thermal insulation, with  floor covering on substructure (cement screed) on the upper side",
    _19_2:
      'Reinforced concrete "fine-ribbed" construction, no thermal insulation. On the lower (basement) side there is no ceiling. On the upper side there is floor covering on its substructure (cement screed)',
    _19_3:
      'Reinforced concrete "fine-ribbed" construction, no thermal insulation. On the lower (basement) side there is a ceiling (mortar over reed and slats). On the upper side these is a floor covering on its substructure (cement screed)',
    _19_4:
      "Reinforced concrete semi-prefabricated construction with hollow clay blocks as filling, no thermal insulation. On the upper side there is a floor covering on its substructure (cement screed).",
    _19_5:
      "Wooden construction (ribs) with decking, embankment, boards, blind floor and floor covering. No ceiling on the basement side.",
    _19_6:
      "Wooden construction (ribs) with decking, embankment, boards, blind floor and floor covering. On the lower (basement) side there is a ceiling (mortar over reed and slats).",
    _19_7:
      "'Prussian arch“ made of solid brick on steel profiles, embankment, boards, floor and floor covering. No ceiling on the basement side.",
    _19_8: "Solid brick arch, embankment, boards, floor and floor covering. No ceiling on the basement side.",
    _19_9: "Reinforced concrete slab with floor insulation. Cement screed on the upper side.",
    _19_10:
      "Reinforced concrete semi-prefabricated construction with hollow clay blocks as filling, with floor insulation. Cement creed on the upper side.",
    _19_11:
      "Reinforced concrete slab with floor insulation. Cement screed above. Additional insulation layer bellow the slab.",
    _20_1: "Basement stone wall, no thermal insulation",
    _20_2: "Basement solid brick wall, no thermal insulation",
    _20_3: "Reinforced concrete basement wall, no thermal insulation",
    _20_4: "Reinforced concrete basement wall, with thermal insulation",
    _21_1: "Earth floor",
    _21_2: "Uninsulated floor (all kinds) above the soil base",
    _21_3: "Uninsulated floor (all kinds) above the cement base",
    _21_4: "Insulated floor (all kinds) above the cement base",
  },
  app_sklopovi_b_select: {
    _1_1: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_2: "Applying of additional rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_3: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_4: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_5: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_6: "Applying of additional rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_7: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_8: "Applying of additional rock mineral wool thermal insulation from the outside, in the ETICS system, with glued fassade ceramic tiles",
    _1_9: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system, with glued fassade ceramic tiles",
    _1_10:
      "Applying of additional rock mineral wool thermal insulation from the outside, in the ETICS system, with glued fassade ceramic tiles",
    _1_11: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_12: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_13: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_14: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_15: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_16: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_17: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_18: "Applying of additional rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_19: "Applying of rock mineral wool thermal insulation from the outside, in the ETICS system",
    _1_20:
      "Applying of additional rock mineral wool thermal insulation from the outside, in the ETICS system, with glued fassade ceramic tiles",
    _5_1: "Demolition of existing external flat roof layers, installation of vapour barrier, rock mineral wool insulation, waterproofing and mechanical protection layers.",
    _5_2: "Demolition of existing external flat roof layers, installation of vapour barrier, rock mineral wool insulation, waterproofing and mechanical protection layers.",
    _5_3: "Demolition of existing external flat roof layers, installation of vapour barrier, rock mineral wool insulation, waterproofing and mechanical protection layers.",
    _5_4: "Demolition of existing external flat roof layers, installation of vapour barrier, rock mineral wool insulation, waterproofing and mechanical protection layers.",
    _5_5: "Demolition of existing external flat roof layers, installation of vapour barrier, rock mineral wool insulation, waterproofing and mechanical protection layers.",
    _5_6: "Demolition of existing external flat roof layers, installation of vapour barrier, rock mineral wool insulation, waterproofing and mechanical protection layers.",
    _7_1: "Demolition of the existing roof cover and its substructure. Installation of vapour barrier, wooden substructure with mineral wool insulation, decking, additional waterproofing membrane and roof cover.",
    _7_2: "Demolition of the existing roof cover and its substructure. Installation of vapour barrier, wooden substructure with mineral wool insulation, decking, additional waterproofing membrane and roof cover.",
    _7_3: "Laying mineral wool insulation between the rafters. Lining of the ceiling with gypsum boards or wooden decking on top of vapour barrier. In case of unsatisfactory insulation thickness, demolition of the existing roof covering and its substructure, installation of additional rafters and rock mineral wool insulation, wooden decking, laying breathable membrane and roof cover on its substructure.",
    _7_4: "Laying mineral wool insulation between the rafters. Lining of the ceiling with gypsum boards or wooden decking on top of vapour barrier. In case of unsatisfactory insulation thickness, demolition of the existing roof covering and its substructure, installation of additional rafters and rock mineral wool insulation, wooden decking, laying breathable membrane and roof cover on its substructure.",
    _7_5: "Demolition of the existing roof covering and its substructure, installation of additional rafters and rock mineral wool insulation, wooden decking, laying breathable membrane and roof covering on its substructure.",
    _7_6: "Demolition of the existing roof covering and its substructure, installation of additional rafters and rock mineral wool insulation, wooden decking, laying breathable membrane and roof covering on its substructure.",
    _10_1: null,
    _10_2: null,
    _10_3: null,
    _10_4: null,
    _10_5: null,
    _10_6: null,
    _10_7: null,
    _10_8: null,
    _10_9: null,
    _10_10: null,
    _10_11: null,
    _10_12: null,
    _10_13: null,
    _10_14: null,
    _10_15: null,
    _10_16: null,
    _10_17: null,
    _10_18: null,
    _10_19: null,
    _10_20: null,
    _10_21: null,
    _10_22: null,
    _10_23: null,
    _10_24: null,
    _10_25: null,
    _10_26: null,
    _10_27: null,
    _10_28: null,
    _10_29: null,
    _10_30: null,
    _10_31: null,
    _10_32: null,
    _13_1: null,
    _13_2: null,
    _13_3: null,
    _13_4: null,
    _13_5: null,
    _13_6: null,
    _13_7: null,
    _13_8: null,
    _18_1:
      "Laying mineral wool insulation on the upper attic side, above the vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_2:
      "Laying mineral wool insulation on the upper attic side, above the vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_3:
      "Laying mineral wool insulation on the upper attic side, above the vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_4:
      "Removing the embankment and laying mineral wool insulation on the upper attic side, above the vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_5:
      "Removing the embankment and laying mineral wool insulation on the upper attic side, above the vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_6:
      "Removing the embankment and laying mineral wool insulation on the upper attic side, above the vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_7:
      "Installation of additional mineral wool insulation on the upper attic side, above the existing insulation layer and vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_8:
      "Installation of additional mineral wool insulation on the upper attic side, above the existing insulation layer and vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_9: "missing",
    _18_101:
      "Laying mineral wool insulation on the upper attic side, above the vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_102:
      "Laying mineral wool insulation on the upper attic side, above the vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_103:
      "Laying mineral wool insulation on the upper attic side, above the vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_104:
      "Removing the embankment and laying mineral wool insulation on the upper attic side, above the vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_105:
      "Removing the embankment and laying mineral wool insulation on the upper attic side, above the vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_106:
      "Removing the embankment and laying mineral wool insulation on the upper attic side, above the vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_107:
      "Installation of additional mineral wool insulation on the upper attic side, above the existing insulation layer and vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_108:
      "Installation of additional mineral wool insulation on the upper attic side, above the existing insulation layer and vapour barrier. Installation of the floating cement screed above the protection membrane, or other mechanical protection.",
    _18_109: "missing",
    _19_1:
      "Removal of the existing floor covering. Laying mineral wool insulation above the slab, over vapour barrier. Installation of floating floor (cement screed) above the protection layer, new floor covering.",
    _19_2:
      "Removal of the existing floor covering. Laying mineral wool insulation above the slab, over vapour barrier. Installation of floating floor (cement screed) above the protection layer, new floor covering.",
    _19_3:
      "Removal of the existing floor covering. Laying mineral wool insulation above the slab, over vapour barrier. Installation of floating floor (cement screed) above the protection layer, new floor covering.",
    _19_4:
      "Removal of the existing floor covering. Laying mineral wool insulation above the slab, over vapour barrier. Installation of floating floor (cement screed) above the protection layer, new floor covering.",
    _19_5:
      "Removal of the existing floor covering and the embankment with wooden battens. Laying mineral wool insulation above the existing blind floor and over the vapour barrier. Installation of floating floor (cement screed) above the protection layer, new floor covering.",
    _19_6:
      "Removal of the existing floor covering and the embankment with wooden battens. Laying mineral wool insulation above the existing blind floor and over the vapour barrier. Installation of floating floor (cement screed) above the protection layer, new floor covering.",
    _19_7:
      "Removal of the existing floor covering and the embankment with wooden battens. Laying mineral wool insulation above the existing blind floor and over the vapour barrier. Installation of floating floor (cement screed) above the protection layer, new floor covering.",
    _19_8:
      "Removal of the existing floor covering and the embankment with wooden battens. Laying mineral wool insulation above the existing blind floor and over the vapour barrier. Installation of floating floor (cement screed) above the protection layer, new floor covering.",
    _19_9:
      "Removal of the existing floor covering. Laying mineral wool insulation above the slab, over vapour barrier. Installation of floating floor (cement screed) above the protection layer, new floor covering.",
    _19_10:
      "Removal of the existing floor covering. Laying mineral wool insulation above the slab, over vapour barrier. Installation of floating floor (cement screed) above the protection layer, new floor covering.",
    _19_11:
      "Removal of the existing floor covering. Laying mineral wool insulation above the slab, over vapour barrier. Installation of floating floor (cement screed) above the protection layer, new floor covering.",
    _20_1: null,
    _20_2: null,
    _20_3: null,
    _20_4: null,
    _21_1: null,
    _21_2: null,
    _21_3: null,
    _21_4: null,
  },
  app_sklopovi_c_select: {
    _1_1: "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_2: "Applying additional rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_3: "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_4: "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_5: "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_6: "Applying additional rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_7: "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_8: "Applying additional rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_9: "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_10:
      "Applying additional rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_11:
      "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_12:
      "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_13:
      "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_14:
      "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_15:
      "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_16:
      "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_17:
      "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_18:
      "Applying additional rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_19:
      "Applying rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _1_20:
      "Applying additional rock mineral wool insulation from the inside, with vapour barrier and gypsum boards on top, on metal substructure.",
    _5_1: "Installation of gypsum boards suspended ceiling with metal substructure, vapour barrier and mineral wool insulation from the inside",
    _5_2: "Demolition of the existing ceiling. Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _5_3: "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation from the inside",
    _5_4: "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation from the inside",
    _5_5: "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation from the inside",
    _5_6: "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation from the inside",
    _7_1: "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation from the inside",
    _7_2: "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation from the inside",
    _7_3: "Laying mineral wool insulation, one layer between the rafters, other layer bellow the rafters within the suspended ceiling made of gypsum boards on a metal substructure, with vapour barrier.",
    _7_4: "Laying additional mineral wool insulation to fit the rafter thickness. Laying additional mineral wool insulation bellow the rafters within the suspended ceiling made of gypsum boards on a metal substructure, with vapour barrier.",
    _7_5: "Laying mineral wool insulation, one layer between the rafters, other layer bellow the rafters within the suspended ceiling made of gypsum boards on a metal substructure, with vapour barrier.",
    _7_6: "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation",
    _10_1: null,
    _10_2: null,
    _10_3: null,
    _10_4: null,
    _10_5: null,
    _10_6: null,
    _10_7: null,
    _10_8: null,
    _10_9: null,
    _10_10: null,
    _10_11: null,
    _10_12: null,
    _10_13: null,
    _10_14: null,
    _10_15: null,
    _10_16: null,
    _10_17: null,
    _10_18: null,
    _10_19: null,
    _10_20: null,
    _10_21: null,
    _10_22: null,
    _10_23: null,
    _10_24: null,
    _10_25: null,
    _10_26: null,
    _10_27: null,
    _10_28: null,
    _10_29: null,
    _10_30: null,
    _10_31: null,
    _10_32: null,
    _13_1: null,
    _13_2: null,
    _13_3: null,
    _13_4: null,
    _13_5: null,
    _13_6: null,
    _13_7: null,
    _13_8: null,
    _18_1:
      "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation.",
    _18_2:
      "Demolition of the existing ceiling. Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _18_3:
      "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _18_4:
      "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation",
    _18_5:
      "Demolition of the existing ceiling. Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _18_6:
      "Demolition of the existing ceiling. Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _18_7:
      "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _18_8:
      "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _18_9: "missing",
    _18_101:
      "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation.",
    _18_102:
      "Demolition of the existing ceiling. Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _18_103:
      "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _18_104:
      "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation",
    _18_105:
      "Demolition of the existing ceiling. Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _18_106:
      "Demolition of the existing ceiling. Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _18_107:
      "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _18_108:
      "Installation of gypsum boards suspended ceiling on metal or wooden substructure, vapour barrier and mineral wool insulation between ribs.",
    _18_109: "missing",
    _19_1:
      "Installation of gypsum boards suspended ceiling on metal substructure, with mineral wool insulation, on the lower (basement) side.",
    _19_2:
      "Installation of gypsum boards suspended ceiling on metal substructure, with mineral wool insulation between ribs, on the lower (basement) side.",
    _19_3:
      "Demolition of the existing ceiling and installation of new gypsum boards suspended ceiling on metal substructure, with mineral wool insulation between ribs, on the lower (basement) side.",
    _19_4:
      "Installation of gypsum boards suspended ceiling on metal substructure, with mineral wool insulation, on the lower (basement) side.",
    _19_5:
      "Installation of gypsum boards suspended ceiling on metal substructure, with mineral wool insulation, on the lower (basement) side.",
    _19_6:
      "Demolition of the existing ceiling and installation of new gypsum boards suspended ceiling on metal or wooden substructure, with mineral wool insulation between ribs, on the lower (basement) side.",
    _19_7:
      "Installation of gypsum boards suspended ceiling on metal substructure, with mineral wool insulation, on the lower (basement) side.",
    _19_8:
      "Installation of gypsum boards suspended ceiling on metal substructure, with mineral wool insulation, on the lower (basement) side.",
    _19_9:
      "Installation of gypsum boards suspended ceiling on metal substructure, with mineral wool insulation, on the lower (basement) side.",
    _19_10:
      "Installation of gypsum boards suspended ceiling on metal substructure, with mineral wool insulation, on the lower (basement) side.",
    _19_11:
      "Installation of gypsum boards suspended ceiling on metal substructure, with mineral wool insulation, on the lower (basement) side.",
    _20_1:
      "Laying of rock mineral wool insulation from the inside, below gypsum boards on the metal frame construction",
    _20_2:
      "Laying of rock mineral wool insulation from the inside, below gypsum boards on the metal frame construction",
    _20_3:
      "Laying of rock mineral wool insulation from the inside, below gypsum boards on the metal frame construction",
    _20_4:
      "Laying of rock mineral wool insulation from the inside, below gypsum boards on the metal frame construction",
    _21_1:
      "Removing of existing floor cover and its construction. Installation of floor hydroinsulation, rock mineral wool thermal insulation, protective membrane, screed and ceramic tiles floor covering",
    _21_2:
      "Removing of existing floor cover and its construction. Installation of floor hydroinsulation, rock mineral wool thermal insulation, protective membrane, screed and wooden floor covering",
    _21_3:
      "Removing of existing floor cover and its construction. Installation of floor hydroinsulation, rock mineral wool thermal insulation, protective membrane, screed and wooden floor covering",
    _21_4:
      "Removing of existing floor cover, its construction and insulation. Installation of floor hydroinsulation, rock mineral wool thermal insulation, protective membrane, screed and wooden floor covering",
  },
  app_materijali_title: {
    1: "NaturBoard FIT PLUS",
    2: "NaturBoard FIT-G PLUS",
    3: "DF",
    4: "FKD-S Thermal",
    5: "FKD-N Thermal",
    6: "SmartRoof Thermal",
    7: "SmartRoof Thermal 2",
    8: "SmartRoof Top",
    9: "Unifit 035",
    10: "Homeseal LDS 0.02",
    11: "Homeseal LDS 5",
    12: "Homeseal LDS 35",
    13: "NaturBoard POD PLUS",
    14: "NaturBoard POD EXTRA",
    15: "FKD-S THERMAL (035)",
    16: "FKD-N THERMAL (034)",
    17: "SMARTROOF TOP (038)",
    18: "SMARTROOF THERMAL (036)",
    19: "HOMESEAL LDS 35 (μεμβρ.)",
    20: "NatuRoll Plus (040 Rol)",
    21: "Ultracoustic (037 Rol)",
    22: "Naturboard 037 (πλάκα)",
    23: "Naturboard 032 (πλάκα)",
    24: "Ultracoustic P (037)",
    25: "Naturboard 035 (πλάκα)",
    26: "NATURBOARD POD STANDARD",
    27: "NATURBOARD POD EXTRA",
    28: "FKD-S THERMAL",
    29: "FKD-N THERMAL",
    30: "SMARTROOF TOP",
    31: "SMARTROOF THERMAL",
    32: "SMARTROOF NORM",
    33: "HOMESEAL LDS 35",
    34: "NATURBOARD FIT PLUS",
    35: "HOMESEAL LDS 0,02",
    36: "HOMESEAL LDS 5",
    37: "DF",
    38: "NATURBOARD POD STANDARD",
    39: "NATURBOARD POD EXTRA",
    40: "MPN Plus 037",
    41: "UNIFIT 035",
    42: "FKD-S Thermal",
    43: "FKD-N Thermal",
    44: "SMARTwall N C1",
    45: "FKL",
    46: "SmartRoof TOP",
    47: "SmartRoof THERMAL",
    48: "DDP-X",
    49: "HOMESEAL LDS 200 AluPlus",
    50: "TERMOTOP",
    51: "HOMESEAL LDS 0,04",
    52: "NaturBoard FIT-G",
    53: "AKUSTIK BOARD",
    54: "HOMESEAL LDS 100 AluPlus",
    55: "NatuRoll PLUS",
    56: "Unifit 035",
    57: "NaturBoard FIT",
    58: "HOMESEAL LDS 35",
    59: "HOMESEAL LDS 36",
    60: "NaturBoard KP",
    61: "NaturBoard TP",
    62: "NaturBoard TPT",
    63: "NaturBoard PARTITION",
    64: "FKD-S THERMAL",
    65: "FKD-N THERMAL",
    66: "SMARTROOF TOP",
    67: "SMARTROOF THERMAL",
    68: "SMARTROOF NORM",
    69: "HOMESEAL LDS 100",
    70: "UNIFIT 035",
    71: "HOMESEAL LDS 0,02",
    72: "HOMESEAL LDS 2",
    73: "PTE",
    74: "PTS",
    75: "AKUSTIK BOARD",
    76: "NATUROLL PRO",
    77: "SMARTwall S C1",
    78: "FKD S THERMAL",
    79: "FKL",
    80: "SmartRoof Top",
    81: "SmartRoof Base",
    82: "HOMESEAL LDS 40",
    83: "HOMESEAL LDS 100",
    84: "UNIFIT 037",
    85: "Homeseal LDS 0.02 UV FixPlus",
    86: "PTE",
    87: "MPE",
    88: "MPN",
    89: "NATURBOARD FIT PLUS",
    90: "UNIFIT 035",
    91: "HOMESEAL LDS 5",
    92: "FKD-S THERMAL",
    93: "FKD-N THERMAL",
    94: "SMARTROOF TOP",
    95: "SMARTROOF THERMAL",
    96: "SmartRoof Base",
    97: "HOMESEAL LDS 35",
    98: "NATURBOARD FIT PLUS",
    99: "HOMESEAL LDS 0,02",
    100: "HOMESEAL LDS 5",
    101: "NATURBOARD POD STANDARD",
    102: "NATURBOARD POD EXTRA",
    103: "NaturBoard FIT",
    104: "NATURBOARD VENTACUSTO",
    105: "AKUSTIK BOARD",
    106: "AKUSTIK ROLL",
    107: "NATURBOARD VENTI",
    108: "UNIFIT 035",
    109: "UNIFIT 037",
    110: "FKD-S THERMAL",
    111: "SMARTWALL N C1",
    112: "SMARTROOF TOP",
    113: "SMARTROOF THERMAL",
    114: "UNIFIT 035",
    115: "HOMESEAL LDS 0,04 FixPlus",
    116: "HOMESEAL LDS 5",
    117: "DF",
    118: "HOMESEAL LDS 100",
    119: "NATURBOARD TPS",
    120: "NATURBOARD POD STANDARD",
    121: "NATURBOARD POD EXTRA",
    122: "HOMESEAL LDS 35",
    123: "NaturBoard TPT",
    124: "NATURBOARD Venti",
    125: "NATURBOARD DF",
    126: "NATURBOARD FIT PLUS",
    127: "DECIBEL",
    128: "SMARTROOF TOP",
    129: "SMARTROOF THERMAL",
    139: "UNIFIT 035",
    140: "FKD-S THERMAL",
    141: "FKD-N THERMAL",
    142: "SMARTROOF BASE",
    143: "Unifit 035",
    144: "Unifit 033",
    145: "NatuRoll PRO",
    146: "NaturBoard 035",
    147: "Akustik Board",
    148: "Ekoboard",
    149: "Homeseal LDS 0.04",
    150: "Homeseal LDS 2",
    151: "Homeseal LDS 35 Fixplus",
    152: "Homeseal LDS Flexplus",
    153: "Homeseal LDS 40",
    154: "Akustik Board",
    155: "Classic 040 Alu",
    156: "FKL-Thermal",
    157: "NaturBoard FIT",
    158: "NaturBoard VENTI",
    159: "NatuRoll Plus",
    160: "Unifit 032",
    161: "OUT-Therm",
    162: "FKD-S THERMAL",
    163: "FKD-N THERMAL",
    164: "SMARTROOF TOP",
    165: "SMARTROOF THERMAL",
    166: "UNIFIT",
    167: "UNIFIT 032",
    168: "PTS",
    169: "PTE",
    170: "NATURBOARD POD STANDARD",
    171: "NATURBOARD POD EXTRA",
    172: "Homeseal LDS 35",
    173: "NATURBOARD 037",
    174: "PTN",
    175: "PTS",
    176: "MPN",
    177: "HOMESEAL LDS 35",
    178: "NATURBOARD FIT PLUS",
    179: "HOMESEAL LDS 0,02",
    180: "HOMESEAL LDS 5",
    181: "FKD-S THERMAL",
    182: "FKD-N THERMAL",
    183: "SMARTROOF TOP",
    184: "SMARTROOF THERMAL",
    185: "SMARTROOF THERMAL 2",
    186: "HOMESEAL LDS 35",
    187: "NATURBOARD FIT PLUS",
    188: "HOMESEAL LDS 0,02",
    189: "HOMESEAL LDS 5",
    190: "NATURBOARD FIIT-G PLUS",
    191: "UNIFIT 035",
    192: "DF",
    193: "NATURBOARD POD STANDARD",
    194: "NATURBOARD POD EXTRA",
    195: "UNIFIT 033",
    196: "HOMESEAL LDS  0.02 UV FixPlus",
    197: "HOMESEAL LDS 2",
    198: "MINERAL PLUS IPB 037",
    199: "MINERAL PLUS IPB 039",
    200: "MINERAL PLUS FCB 034",
    201: "MINERAL PLUS FCB 034 KD",
    202: "MINERAL PLUS FCB 033 Extra",
    203: "MINERAL PLUS FCB 033 Extra KD",
    204: "MINERAL PLUS FCB 032 Pro",
    205: "MINERAL PLUS FCB 032 Pro KD",
    206: "EARTHWOOL 043",
    207: "EARTHWOOL 043 ALU",
  },
  app_materijali_select: {
    1: null,
    2: null,
  },
  loc_zone_title: "Country zone",
  loc_hd_title: "HD (Heating Days)",
  loc_ta_title: "TA (Temperature Average)",
  loc_hdd_ref_title: "HDD (reference value)",
  loc_ti_ref_title: "TI (reference value)",
  loc_hdd_title: "HDD (calculated value)",
  loc_internal_title: "Internal temperature",
  loc_reference_title: "Temperature reference",
  typ_pozicija_select: ["Free standing", "In a row"],
  typ_stanje_title: "New house",
  pos_nagib_title: "Hip > 45°",
  pos_nagib_select: {
    1: "Less than 45 deg",
    2: "More than 45 deg",
  },
  pos_standard_select: {
    0: "Standard",
    1: "Recomended",
    2: "NZEB",
  },
  pos_u_max_options_title: "U max options",
  typ_floorarea_title: "Total floor heated area",
  app_height_title: "Floor height",
  atc_height_title: "Attic height:",
  typ_brojfasada_title: "Number of windy facades",
  typ_constdate_title: "Construction date",
  loc_sun_select: ["Exposed", "Medium", "Shadowed"],
  loc_wind_select: ["Very", "Medium", "Sheltered"],
  app_back_title: "Back",
  app_next_title: "Next",
  app_delete_title: "Delete",
  app_confirm_title: "Confirm",
  app_proceed_title: "Proceed",
  app_cancel_title: "Cancel",
  app_settings_title: "Settings",
  app_change_settings_title: "Change settings",
  app_choose_house_title: "Choose your house",
  app_summary_title: "SUMMARY",
  app_cta_title: "CTA",
  app_sprat_title: "floor",
  app_spratovi_title: "floors",
  app_intervention_reset_title: "If you proceed, all interventions will be reset!",
  app_intervention_20_21_reset_title:
    "If you proceed, interventions Floor on the ground and Basement wall will be reset!",
  app_intervention_all_reset_title:
    "If you proceed, all manually set window area, roof window area and interventions will be reset!",
  app_intervention_20_21_all_reset_title:
    "If you proceed, all manually set window area, roof window area and interventions Floor on the ground and Basement wall will be reset!",
  pos_window_select: ["Plastic", "Wooden", "Metal"],
  typ_window_delete_title:
    "If you proceed, all manually set window area, and roof window area data will be reset to default value!",
  typ_data_coerce_title: "Value out of range. Automatically adjusted to regular value!",
  pos_20_21_title:
    "If you enter basement wall intervetion first, you can't change slab on the ground intervention later, without basement wall intervention reset.",
  pos_21_20_start_title: "Basement wall intervention will be reset if slab on the ground is changed.",
  pos_21_20_delete_title: "Slab on the ground intervention will reset basement wall intervention too.",
  pos_intervention_reset_title: "Confirm intervention reset.",
  app_start_title: "Click to go to next step",
  app_finish_title: "Call to action",
  loc_select_title: "LOCATION PARAMETERS",
  loc_additional_title: "ADDITIONAL DATA",
  loc_calculation_title: "CALCULATION",
  typ_select_title: "TYPE",
  typ_geometry_title: "GEOMETRY OF HOUSE",
  typ_heating_title: "How do you heat your house?",
  app_less_parameters_title: "Less options",
  app_more_parameters_title: "More options",
  pos_heading_title: "POSITIONS",
  pos_existing_title: "EXISTING STATE",
  pos_intervention_title: "INTERVENTION",
  pos_thickness_title: "Wall thickness [cm]",
  pos_insulation_title: "Insulation thickness (cm)",
  pos_expert_title: "Expert mode",
  pos_inside_title: "Inside insulation",
  pos_inside_description_title: "Insulation is installed inside",
  pos_outside_title: "Outside insulation",
  pos_outside_description_title: "Insulation is installed outside",
  pos_u_value_options_title: "U value options",
  pos_u_value_low_title: "Nedostatočné",
  pos_u_value_good_title: "Satisfied",
  list_heading_title: "LIST OF INTERVENTIONS",
  list_existing_title: "Existing State",
  list_intervention_title: "Intervention solution",
  calc_calculation_title: "CALCULATION",
  calc_existing_title: "Existing",
  calc_intervention_title: "Intervention",
  calc_heat_title: "HEAT",
  calc_energy_title: "Energy class",
  calc_offer_title: "REQUEST OFFER",
  calc_again_title: "Or calculate again",
  calc_consumption_title: "Consumption",
  calc_savings_title: "Savings",
  app_privacy_title: "Privacy policy",
  app_terms_title: "Terms and conditions",
  app_header_title: "Energy Efficiency Calculator",
  calc_disclaimer_title:
    "All monetary values are based on average prices and there might be a variation depending on where you live and what type of agreement you have",
  typ_floornumber_title: "Number of floors",
  typ_vrstatla_title: "Soil type:",
  typ_vrstatla_select: ["Clay, dike", "Sand, gravel", "Rock"],
  pos_position_select: {
    1: "Facade wall",
    5: "Flat roof",
    7: "Hip roof",
    10: "Windows",
    13: "Doors",
    18: "Ceiling under unheated attic",
    19: "Floor above unheated basement",
    20: "Basement wall",
    21: "Slab on the ground",
    60: "Roof windows",
  },
  typ_house_title: {
    hahb: "Heated attic and heated basement",
    hanhb: "Heated attic and non heated basement",
    nhahb: "Non heated attic and heated basement",
    nhanhb: "Non heated attic and non heated basement",
    pnhb: "Flat roof and non heated basement",
    hat: "Heated attic",
    nhat: "Non heated attic",
    pt: "Flat roof",
    ao: "Attic only",
    phb: "Flat roof and heated basement",
  },
  typ_override_window_title: "Total windows area:",
  typ_override_roof_window_title: "Total roof windows area:",
  typ_dubina_title: "Depth:",
  typ_grejanje_title: {
    1: "Heating oil",
    2: "Gas",
    3: "Coal",
    4: "Wood",
    5: "Electricity",
    6: "Distant heating – fossil",
    7: "Distant heating – Cogeneration",
    8: "Ground heating",
    9: "Wood pellets",
    10: "Kerosene",
    11: "Coal brickets",
    12: "Antracite",
    13: "Lignite",
    14: "Split sistem",
    15: "Crude oil",
    16: "Propane",
  },
  typ_mobile_carousel_click_title: "Tap on icon to select",
  typ_desktop_carousel_click_title: "Click on icon to select",
  typ_select_house_title: "Enter the house parameters",
  pos_description_title: "Confirm the existing status of below positions and choose the intervention",
  pos_intervention_on_title: "Check to add insulation",
  pos_confirm_title: "Confirm the existing status",
  pos_confirm_all_title: "Confirm all",
  pos_above_title: "Insulation above",
  pos_below_title: "Insulation below",
  pos_izaberi_stanje_title: "Choose the existing status",
  pos_idite_desno_title:
    "Confirm the existing status without the intervention or check INTERVENTION, and then confirm all.",
  pos_aktiviraj_title: "Click for intervention",
  pos_deaktiviraj_title: "Deactivate intervention",
  app_additional_options_title: "Additional options",
  app_back_to_house_title: "Back to house selection",
  list_what_isolation_title: "What to insulate and with what",
  list_solution_title: "Insulation sollution",
  list_no_intervention_title: "Existing state kept",
  list_no_intervention_detail_title: "Existing state of the position on the house kept!",
  list_no_position_title: "Position not defined!",
  list_no_position_detail:
    "Chose the type of the position on your house by clicking on the blue marker on the house model.",
  calc_savings_desktop_title: "Annual money and energy savings",
  calc_heating_desktop_title: "Heating",
  pos_new_title: "New condition",
  app_created_title: "Created and developed by:",
  app_arhitektura_title: "Arhitecture and Energy",
  app_reserved_title: "All rights reserved.",
  typ_house_selection_title: "Enter house data",
  typ_house_parameters_title: "Choose another house type",
  app_ok_title: "OK",
  pos_nointervention_info_title:
    "Even if you don’t want to intervene on some of the positions, you have to confirm existing state of every position so the choices would be included in final calculation",
  list_change_title: "Change",
  pos_current_insulation_title: "Current insulation tickness",
  list_define_position_title: "Define position",
  list_add_insulation_title: "Add insulation",
  typ_ceiling_select: ["Passable", "Unpassable"],
  typ_ceiling_title: "Attic condition",
  typ_house_geometry_title: "Enter a parameter for the house",
  pos_define_positions_title: "What is your house made of?",
  pos_define_interventions_title: "Select a position for intervention",
  pos_postojece_proracun_title: "Calculation of the current situation",
  pos_info_1_title:
    "Click on the blue circle on the house left to describe in more detail of which materials parts of your house has been made.",
  pos_info_2_title: "When you confirm the current status of all positions you can go to the next step.",
  pos_info_click_title: "Click on the next position on the house",
  pos_info_title_title: "Now you have defined what your house is made of.",
  pos_info_subtitle_1_title:
    "If you want to go back and make additional check of existing condition or make some changes, click on the green circle on the house or on the name of the part of the house  in table on the left.",
  pos_info_subtitle_2_title: "If you have finished with defining, click on the “Next“ button",
  calc_title_a_title: "Great!",
  calc_subtitle_a_title: "Your house is in good condition.",
  calc_description_a_title:
    "If you want to additionaly improve the condition of your house, click on the “Improve“ button.",
  calc_title_b_title: "Not bad.",
  calc_subtitle_b_title: "It could be much better!",
  calc_description_b_title: "Let‘s additionaly improve the condition of your house by clicking on the “Improve“ button",
  calc_title_c_title: "Not good!",
  calc_subtitle_c_title: "Your house spends too much!",
  calc_description_c_title: "Let‘s improve the condition of your house by clicking on the “Improve“ button",
  calc_confirm_title: "Improve",
  calc_year_title: "ANNUAL consumption of MONEY AND ENERGY",
  calc_class_title: "Energy class*",
  calc_uporedno_title: "Comparative status of annual consumption",
  calc_advanced_title: "Improved condition",
  pos_intervention_start_title: "Click on the position of the house on which you want to improve the situation.",
  pos_intervention_back_title: "Keep the current status.",
  list_materijal_confirm_title: "Confirm position",
  list_more_title: "Do you want to improve some more position of the house?",
  list_more_yes_title: "Yes, I want",
  list_more_no_title: "I don‘t want",
  list_final_top_title: "If you have finished with adding isolation, click “Finish intervention“ button",
  list_final_middle_title: "If you want to isolate another position, click on the same position of the house.",
  list_final_title: "Finish intervention",
  list_position_title: "List of positions",
  list_additional_title: "If you want to isolate another position, click on the same position of the house.",
  calc_final_title: "Final calculation",
  typ_house_tip_title: "Choose the type of your house",
  pos_position_from_select: {
    1: "Choose the existing condition of Your facade wall",
    5: "Choose the existing condition of Your flat roof",
    7: "Choose the existing condition of Your pitched roof",
    10: "Choose the existing condition of Your windows",
    13: "Choose the existing condition of Your doors",
    18: "Choose the existing condition of Your ceiling under unheated attic",
    19: "Choose the existing condition of Your floor above an unheated basement",
    20: "Choose the existing condition of Your wall in the ground",
    21: "Choose the existing condition of Your floor on the ground",
    60: "Choose the existing condition of Your roof windows",
  },
  calc_again_desktop_title: "Calculate again",
  energy_disclaimer_title: null,
  app_welcome_title: "Welcome",
  app_politika_privatnosti_title: "http://www.kamenavuna.com/politika-privatnosti-kalkulator/",
  app_uslovi_koriscenja_title: "http://www.kamenavuna.com/uslovi-koriscenja-kalkulator/",
};
